import React, { createContext, useContext, useState } from "react";

import { useGetModelFormData } from "../../../../hooks/useGetModelFormData";
import { OfferAppTabValuesType, offerAppTabs } from "../utils/offer-tabs";
import { IOffer } from "../interfaces/interfaces";
import { useTranslation } from "react-i18next";

export const MainContext = createContext<any>(null);

export const MainProvider = ({ children }) => {
    const [selectedTab, setSelectedTab] = useState<OfferAppTabValuesType>(offerAppTabs.contracts);
    const [selectedClient, setSelectedClient] = useState<number | undefined>(undefined);
    const [selectedMainRecord, setSelectedMainRecord] = useState<IOffer[]>([]); // TODO! dodać workflow do contracts | IContract[]
    const [refreshMainData, setRefreshMainData] = useState<Function | undefined>(undefined);

    const { t } = useTranslation();

    const { formData: workflowStatuses } = useGetModelFormData<any>({
        options: { status: { app: "client", model: "Deal" } },
        mapFormData: (data) => data.status.map((o) => ({ ...o, label: t(o.label) })),
    });

    return (
        <MainContext.Provider
            value={{
                selectedTab,
                setSelectedTab,
                selectedClient,
                setSelectedClient,
                selectedMainRecord,
                setSelectedMainRecord,
                refreshMainData,
                setRefreshMainData,
                editableMainRecord: selectedMainRecord[0]?.workflowStep?.editableData,
                workflowStatuses,
            }}
        >
            {children}
        </MainContext.Provider>
    );
};

export const useMainContext = (): IUseMainContext => {
    const {
        selectedTab,
        setSelectedTab,
        selectedClient,
        setSelectedClient,
        selectedMainRecord,
        setSelectedMainRecord,
        refreshMainData,
        setRefreshMainData,
        editableMainRecord,
        workflowStatuses,
    } = useContext(MainContext);

    return {
        selectedTab,
        setSelectedTab,
        selectedClient,
        setSelectedClient,
        selectedMainRecord,
        setSelectedMainRecord,
        refreshMainData,
        setRefreshMainData,
        editableMainRecord,
        workflowStatuses,
    };
};

interface IUseMainContext {
    selectedTab: OfferAppTabValuesType;
    setSelectedTab: (arg: OfferAppTabValuesType) => void;
    selectedClient: number | undefined;
    setSelectedClient: (arg: number) => void;
    selectedMainRecord: IOffer[]; // TODO! dodać workflow do contracts | IContract[]
    setSelectedMainRecord: (arg: IOffer[]) => void;
    refreshMainData: Function | undefined;
    setRefreshMainData: Function;
    editableMainRecord: boolean;
    workflowStatuses: ILabelValue<number>[];
}
